import { DatasetSourceV2 } from 'polly-commons';
import { drugBasedAtlasList, geneBasedAtlasList } from '../../constants/omixatlas.constants';
import { DatasetTag, DatasetTagsList } from '../interfaces';

export function extractDatasetTags(tagGroup: string, tags: string[] | string, tagType: string): DatasetTag[] {
  const extractedDatasetTags: DatasetTag[] = [];
  if (tags[0] === 'None' || tags.length === 0) return extractedDatasetTags;
  if (Array.isArray(tags)) {
    tags.forEach((tag: string) => {
      if (typeof(tag) === 'string') {
        const datasetTag: DatasetTag = {
          tagIdentifier: tagGroup,
          tagName: tag,
          tagCategory: tagType,
        };
        extractedDatasetTags.push(datasetTag);
      }
    });
  } else {
    const datasetTag: DatasetTag = {
      tagIdentifier: tagGroup,
      tagName: tags,
      tagCategory: tagType,
    };
    extractedDatasetTags.push(datasetTag);
  }
  return extractedDatasetTags;
}

export function extractTags(datasetSource: DatasetSourceV2, repoName: string): DatasetTagsList {
  let datasetTags: DatasetTag[] = [];
  let partialTags: DatasetTag[] = [];
  let diseaseTags: DatasetTag[] = [];
  let strainTags: DatasetTag[] = [];
  let organismTags: DatasetTag[] = [];
  let tissueTags: DatasetTag[] = [];
  let drugTags: DatasetTag[] = [];
  let cellLineTags: DatasetTag[] = [];
  let cellTypeTags: DatasetTag[] = [];
  let dataTypeTags: DatasetTag[] = [];
  let datasetSourceTags: DatasetTag[] = [];
  let geneTags: DatasetTag[] = [];
  let repoTags: DatasetTag[] = [];
  let ukbbTags: DatasetTag[] = [];
  let drugBasedTags: DatasetTag[] = [];

  if (drugBasedAtlasList.includes(repoName)) {
    if (datasetSource.cell_line) drugBasedTags = [...extractDatasetTags('drugBased', datasetSource.cell_line, 'Cell Line')];
    if (datasetSource.compound) drugBasedTags = [...drugBasedTags, ...extractDatasetTags('drugBased', datasetSource.compound, 'Compound')];
    if (datasetSource.assay_type) drugBasedTags = [...drugBasedTags, ...extractDatasetTags('drugBased', datasetSource.assay_type, 'Assay Type')];
    if (datasetSource.experiment) drugBasedTags = [...drugBasedTags, ...extractDatasetTags('drugBased', datasetSource.experiment, 'Experiment')];
    if (datasetSource.ic50) drugBasedTags = [...drugBasedTags, ...extractDatasetTags('drugBased', datasetSource.ic50, 'IC50')];
    if (datasetSource.data_type) {
      drugBasedTags = [...drugBasedTags, ...extractDatasetTags('drugBased', datasetSource.data_type, 'Data Type')];
    }
  } else {
    if (datasetSource.curated_organism) organismTags = extractDatasetTags('organism', datasetSource.curated_organism, 'Organism');
    if (datasetSource.data_type) dataTypeTags = extractDatasetTags('dataType', datasetSource.data_type, '');
    if (geneBasedAtlasList.includes(repoName)) {
      if (datasetSource.src_repo) repoTags = [...extractDatasetTags('repo', datasetSource.src_repo, '')];
      if (datasetSource.gene) geneTags = [...extractDatasetTags('gene', datasetSource.gene, '')];
      if (datasetSource.ukbb_description) ukbbTags = [...extractDatasetTags('ukbb', datasetSource.ukbb_description, '')];
    } else {
      if (datasetSource.curated_disease) diseaseTags = [...extractDatasetTags('disease', datasetSource.curated_disease, 'Disease')];
      if (datasetSource.curated_strain) strainTags = [...extractDatasetTags('strain', datasetSource.curated_strain, 'Strain')];
      if (datasetSource.curated_tissue) tissueTags = extractDatasetTags('tissue', datasetSource.curated_tissue, 'Tissue');
      if (datasetSource.curated_drug) drugTags = extractDatasetTags('drug', datasetSource.curated_drug, '');
      if (datasetSource.curated_cell_line) cellLineTags = extractDatasetTags('cellLine', datasetSource.curated_cell_line, '');
      if (datasetSource.curated_cell_type) cellTypeTags = extractDatasetTags('cellType', datasetSource.curated_cell_type, '');
      if (datasetSource.dataset_source) datasetSourceTags = extractDatasetTags('datasetSource', datasetSource.dataset_source, '');
    }
  }
  datasetTags = [
    ...diseaseTags,
    ...strainTags,
    ...organismTags,
    ...tissueTags,
    ...cellLineTags,
    ...drugTags,
    ...cellTypeTags,
    ...dataTypeTags,
    ...datasetSourceTags,
    ...geneTags,
    ...repoTags,
    ...ukbbTags,
    ...drugBasedTags,
  ];
  datasetTags = datasetTags.filter(tag => !tag.tagName.includes('none'))
  if (datasetTags.length > 7) {
    const tags = [...datasetTags];
    partialTags = [...tags.slice(0, 7)];
    datasetTags = [...tags.slice(7)];
  }
  return {
    datasetTags,
    partialTags,
  };
}

export function getTextFormatted(descriptionText: string | string []): string {
  const formattedText: string = typeof descriptionText === 'string' ? descriptionText : descriptionText[0];
  return formattedText;
}
